import 'core-js/es/string/pad-start';
import Vue from 'vue';

// Expect date as a String(20200415 - YYYYMMDD) returns date DD/MM/YYYY
export const dateFormator = (val: string) => {
	const defaultDateFormat = val.substr(0, 4) + ' ' + val.substr(4, 2) + ' ' + val.substr(6, 2);
	const getMonth = monthFormator(parseFloat(defaultDateFormat.split(' ')[1]));
	const indexOfMonth = defaultDateFormat.split(' ')[1];
	const updatedDateFormat = defaultDateFormat.replace(indexOfMonth, getMonth);
	return updatedDateFormat.split(' ').reverse().join(' ');
};

const monthFormator = (val: number) => {
	const months = [
		'January',
		'February',
		'March',
		'April',
		'May',
		'June',
		'July',
		'August',
		'September',
		'October',
		'November',
		'December',
	];
	return months[val - 1];
};

// converts string date(DD/MM/YYYY) into new Date() format
export const convertDateFormat = (str: string) => {
	// const mdy = str.split('/').map(Number);
	// return new Date(mdy[2], mdy[1] - 1, mdy[0]);
	return new Date(str);
};

export function dateDiff(first: Date, second: Date) {
	return Math.round((second.valueOf() - first.valueOf()) / (1000 * 60 * 60 * 24));
}

export function dateShortString(date: Date) {
	return new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'long', year: 'numeric', }).format(date);
}

export function generateDateFormatForApi(date: Date) {
	return `${date.getFullYear()}-${(date.getMonth() + 1).toString(10).padStart(2, '0')}-${date.getDate().toString(10).padStart(2, '0')}T00:00:00.000Z`;
}

export const getAge = (dateString: string): number => {
	const today = new Date();
	const birthDate = new Date(dateString);
	const age = today.getFullYear() - birthDate.getFullYear();
	const m = today.getMonth() - birthDate.getMonth();
	if (m < 0 || (m === 0 && today.getDate() - 1 < birthDate.getDate())) {
		return age - 1;
	}

	return age;
};

export const validDirectDebitDates: number[] = [1, 5, 10, 15, 20, 25,];

export const convertNumberIntoDate = async (number: number) => {
	let currentDate = new Date();
	if (number === currentDate.getDate()) {
		currentDate = new Date(currentDate.setMonth(currentDate.getMonth() + 1));
		const data = await Vue.selfServeApi.directDebitDirectDebitDateCalculatorList({
			date: `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate()}`,
		});
		return new Date(data.result.directDebitDate);
	}
	// const validDates = [1, 5, 10, 15, 20, 25,];
	let result = currentDate;
	let thresholdDate = new Date();
	thresholdDate.setDate(thresholdDate.getDate() + 14);
	thresholdDate = new Date(thresholdDate.getFullYear(), thresholdDate.getMonth(), thresholdDate.getDate());

	while (result.getDate() !== number) {
		result.setDate(result.getDate() + 1);
	}

	// eslint-disable-next-line no-unmodified-loop-condition
	while (result < thresholdDate || !validDirectDebitDates.includes(result.getDate())) {
		if (validDirectDebitDates.includes(result.getDate())) {
			const response = await Vue.selfServeApi.directDebitDirectDebitDateCalculatorList({
				date: `${result.getFullYear()}-${result.getMonth() + 1}-${result.getDate()}`,
			});
			result = new Date(response.result.directDebitDate);
			if (result >= thresholdDate) {
				break;
			}
		}
		result.setDate(result.getDate() + 1);
	}
	const response = await Vue.selfServeApi.directDebitDirectDebitDateCalculatorList({
		date: `${result.getFullYear()}-${result.getMonth() + 1}-${result.getDate()}`,
	});
	result = new Date(response.result.directDebitDate);

	return result;
};

export const toDateFormat = (value: Date): string | null => {
	if (!value) {
		return null;
	}

	return `${value
		.getFullYear()}-${(value.getMonth() + 1)
		.toString(10)
		.padStart(2, '0')}-${value.getDate()
		.toString(10)
		.padStart(2, '0')}`;
};
